import { type ResourcesConfig, Amplify } from 'aws-amplify';
import { z } from 'zod';

export const AmplifyConfigSchema = z
  .object({
    USER_POOL_ID: z.string(),
    USER_POOL_CLIENT_ID: z.string(),
  })
  .transform(
    ({ USER_POOL_ID, USER_POOL_CLIENT_ID }) =>
      ({
        Auth: {
          Cognito: {
            userPoolId: USER_POOL_ID,
            userPoolClientId: USER_POOL_CLIENT_ID,
          },
        },
      }) satisfies ResourcesConfig,
  );

export const amplifyInit = (
  cognitoConfig: z.infer<typeof AmplifyConfigSchema>,
) => Amplify.configure(cognitoConfig, { ssr: true });
